<template>
  <article class="layout-section -align-side -reverse">
    <figure class="layout-section__figure -reverse" :style="{ backgroundImage }" />

    <section class="layout-section__content">
      <h2 class="layout-section__title">{{ wp.publications.title }}</h2>
      <p>
        {{ wp.publications.text }}
      </p>

      <RouterLink :to="{ name: 'about-members' }" class="button layout-section__cta">
        Explorez nos membres
        <SvgIcon id="action-arrow" />
      </RouterLink>
    </section>
  </article>
</template>

<script>
export default {
  name: 'ProjectsMore',
  inject: ['wp'],
  computed: {
    backgroundImage() {
      return `url(${this.wp.publications.image})`
    }
  }
}
</script>
